import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config';
import throttle from 'lodash/throttle';

const fullConfig = resolveConfig(tailwindConfig);

export default {
  data() {
    return {
      showMenu: false,
      showSubMenu: 'gemeinde',
      currentPosition: 0,
      previousPosition: 0,
      windowWidth: window.innerWidth,
      dropdownFocusTimeout: null
    };
  },
  computed: {
    isScrollingUp() {
      return this.previousPosition > this.currentPosition;
    },

    isDetached() {
      return this.currentPosition > 200;
    },

    isHidden() {
      return this.isDetached && !this.isScrollingUp;
    }
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('keydown', this.handleGlobalKeydown);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('keydown', this.handleGlobalKeydown);
  },

  methods: {
    onResize: throttle(function() {
      this.windowWidth = window.innerWidth;

      if (window.innerWidth >= parseInt(fullConfig.theme.screens.sm, 10) && this.showMenu) {
        this.showMenu = false;
      }
    }, 300),

    onScroll: throttle(function() {
      this.previousPosition = this.currentPosition;
      this.currentPosition = window.scrollY;
    }, 300),

    arrowClick(location) {
      if (this.showSubMenu == location) {
        return (this.showSubMenu = '');
      }
      this.showSubMenu = location;
    },

    toggleDropdown(location) {
      if (this.showSubMenu == location) {
        this.showSubMenu = '';
      } else {
        this.showSubMenu = location;
      }
    },

    closeDropdown(location) {
      if (this.showSubMenu == location) {
        this.showSubMenu = '';
      }
    },

    onDropdownFocus(location) {
      // Clear any existing timeout
      if (this.dropdownFocusTimeout) {
        clearTimeout(this.dropdownFocusTimeout);
        this.dropdownFocusTimeout = null;
      }

      // Show dropdown on focus for desktop
      if (window.innerWidth >= parseInt(fullConfig.theme.screens.lg, 10)) {
        this.showSubMenu = location;
      }
    },

    onDropdownBlur(location) {
      // Delay hiding the dropdown to allow focus to move to submenu items
      this.dropdownFocusTimeout = setTimeout(() => {
        // Only hide if focus hasn't moved to a submenu item
        const activeElement = document.activeElement;
        const submenu = document.getElementById(`submenu-${location}`);

        if (!submenu || !submenu.contains(activeElement)) {
          if (this.showSubMenu == location) {
            this.showSubMenu = '';
          }
        }
      }, 150);
    },

    handleGlobalKeydown(event) {
      // Close all dropdowns on Escape key
      if (event.key === 'Escape') {
        this.showSubMenu = '';
      }
    }
  }
};
